module.exports = __webpack_public_path__ + "static/banner-tablet-98e761adc82fe4ee4b13d8b6bb6a9950.png";